import { resolveImageSource } from '../image-source';
import type { FormElement, ImageProperties } from '../../model/form.types';
import type { ImageDefinition } from '../../model/types';

type ImageElement = FormElement & { properties: ImageProperties };

export const imageDefinition: ImageDefinition<ImageElement> = {
  kind: 'image',
  type: 'IMAGE',
  compile: (element) => ({
    kind: 'image',
    id: element.id,
    type: 'IMAGE',
    source: resolveImageSource(element.properties),
    visible: true,
    element,
  }),
};
